export const countConversationsAssignedUniqueCustomer = {
  analysisType: 'count_unique',
  eventCollection: 'conversation.assigned',
  key: 'countConversationsAssignedUniqueCustomer',
  targetProperty: 'conversation.customer.id',
}
